/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, Inject, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlansApi } from 'src/app/app-data/state/PlansApi';
import * as strings from '@touchplan/strings';
import { Subject } from 'rxjs';
import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';
import { DynamicFlagTypes } from '@touchplan/feature-flags';
import { takeUntil } from 'rxjs/operators';

export interface ISchedulingDialogInput {
	plansApi: PlansApi;
}

@Component({
	selector: 'app-project-scheduling',
	templateUrl: './project-scheduling.component.html',
	styleUrls: ['./project-scheduling.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectSchedulingComponent implements OnInit, OnDestroy {
	public strings = strings;
	public DynamicFlagTypes = DynamicFlagTypes;
	private shutdownSubject$ = new Subject<void>();

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ISchedulingDialogInput,
		protected dialogRef: MatDialogRef<ProjectSchedulingComponent>,
		protected featureFlagManager: FeatureFlagManager
	) {}

	public ngOnInit(): void {
		this.featureFlagManager
			.getFlag$(DynamicFlagTypes.PROJECT_SCHEDULE_ENABLED)
			.pipe(takeUntil(this.shutdownSubject$))
			.subscribe((enabled) => {
				// after the dialog is already up on screen, feature flag(s) can be adjusted
				// close the dialog if flags are changed and no scheduling feature is enabled any more
				if (!enabled) {
					this.dialogRef.close();
				}
			});
	}

	public ngOnDestroy(): void {
		this.shutdownSubject$.next();
		this.shutdownSubject$.complete();
	}
}
